import { FormControl, Grid, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, InputLabel, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Alert } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete, LocalOffer as IconDescuento } from "@mui/icons-material";
import api from "../services/api";
import * as participanteService from "../services/participanteService";
import descuentoService from "../services/descuentoService";
import descuentoCatalogoService from "../services/descuentoCatalogoService";
import * as catalogoService from "../services/catalogoService";
import DialogoCredenciales from "./DialogoCredenciales";
import moment from 'moment';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setEntity, setData, add, remove, setParticipantes, setEstados
    , setValidations, activeValidations
} from '../redux/therapyMemberSlice'
import DialogYesNo from './DialogYesNo'
import { FormHelperText as HelperText } from '@mui/material';

const TherapyMember = (props) => {
    const isReadOnly = props.isReadOnly;
    const params = useParams();
    const idFilialTerapia = useSelector((state) => state.therapy?.entity?.idFilial) || 0;
    const idFilialUsuario = useSelector((state) => state.seguridad?.idFilial) || 0;
    const idFilialEfectiva = idFilialTerapia || idFilialUsuario || 0;
    const entity = useSelector((state) => state.therapyMember.entity)
    const defaultEntity = useSelector((state) => state.therapyMember.defaultEntity)
    const listParticipantes = useSelector((state) => state.therapyMember.listParticipantes)
    const listEstados = useSelector((state) => state.therapyMember.listEstados)
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    const [numeroDocumentoFocus, setNumeroDocumentoFocus] = useState(null);
    const therapy = useSelector((state) => state.therapy.entity);
    const [dialogoCredencialesAbierto, setDialogoCredencialesAbierto] = useState(false);
    const [dialogoDescuentoAbierto, setDialogoDescuentoAbierto] = useState(false);
    // Token de la aprobacion del descuento: lo devuelve el dialogo de
    // credenciales y lo pide la API cuando quien registra no tiene
    // "descuento.editar".
    const [tokenAprobacion, setTokenAprobacion] = useState("");
    const [participanteDescuento, setParticipanteDescuento] = useState(null);
    const [listDescuentoCatalogo, setListDescuentoCatalogo] = useState([]);
    const [formDescuento, setFormDescuento] = useState({
        idDescuentoCatalogo: 0, idTipoCalculo: 0, valor: 0, isPorcentaje: true,
        fechaInicio: new Date().toISOString().slice(0,10),
        fechaFin: new Date(Date.now() + 365 * 24 * 3600 * 1000).toISOString().slice(0,10), idEstado: 2,
    });
    const [mensajeDescuento, setMensajeDescuento] = useState({ open: false, severity: "error", text: "" });
    const mostrarMensajeDescuento = (severity, text) => setMensajeDescuento({ open: true, severity, text });
    const [listTiposDescuento, setListTiposDescuento] = useState([]);
    const validate = useSelector((state) => state.therapyMember.validationActive);
    const dispatch = useDispatch();

    var validation = {
        AtLeastOneRow: {
            error: entity.length == 1
                &&
                (
                    entity[0].idParticipante == 0
                ),
            message: "Debe haber por lo menos un participante",
        },
    }

    const setItemValue = (numero, name, value) => {
        dispatch(setData({numero: numero, name: name, value: value}))
    }

    // Un participante no puede tener dos descuentos: si ya tiene uno referenciado
    // no se deja registrar otro.
    const abrirRegistroDescuento = (row) => {
        if (row.idDescuento > 0) {
            mostrarMensajeDescuento("warning", "El participante ya tiene un descuento (" + (row.codigoDescuento || "") + "). No se puede registrar otro.");
            return;
        }
        setFormDescuento({
            idDescuentoCatalogo: 0, idTipoCalculo: 0, valor: 0, isPorcentaje: true,
            fechaInicio: new Date().toISOString().slice(0,10),
            fechaFin: new Date(Date.now() + 365 * 24 * 3600 * 1000).toISOString().slice(0,10), idEstado: 2,
        });
        setParticipanteDescuento(row);
        setDialogoCredencialesAbierto(true);
    }

    const registrarDescuento = async () => {
        if (!formDescuento.idDescuentoCatalogo || formDescuento.idDescuentoCatalogo <= 0) {
            mostrarMensajeDescuento("error", "Seleccione un descuento del catalogo.");
            return;
        }
        if (!formDescuento.fechaInicio || !formDescuento.fechaFin) {
            mostrarMensajeDescuento("error", "Complete las fechas de inicio y fin del descuento.");
            return;
        }
        if (formDescuento.fechaFin < formDescuento.fechaInicio) {
            mostrarMensajeDescuento("error", "La fecha fin no puede ser menor que la fecha inicio.");
            return;
        }
        try {
            const tarifa = therapy && therapy.montoTarifa ? therapy.montoTarifa : 0;
            const id = await descuentoService.addUpdateDescuento({ id: 0, idDescuentoCatalogo: formDescuento.idDescuentoCatalogo, idTipoCalculo: formDescuento.idTipoCalculo, valor: formDescuento.valor, fechaInicio: formDescuento.fechaInicio, fechaFin: formDescuento.fechaFin, idEstado: formDescuento.idEstado }, tokenAprobacion);
            const tipoSel = (listTiposDescuento || []).find((t) => (t.id || t.idCatalogo) === formDescuento.idTipoCalculo);
            // 316 = Porcentaje: la tarifa por el valor. Cualquier otro tipo es monto fijo.
            const esPorcentaje = formDescuento.idTipoCalculo === 316
                || (tipoSel && String(tipoSel.codigo || tipoSel.abreviado || "").toLowerCase().includes("porc"));
            const monto = esPorcentaje ? (tarifa * formDescuento.valor / 100) : formDescuento.valor;
            setItemValue(participanteDescuento.numero, "idDescuento", id);
            const catSel = (listDescuentoCatalogo || []).find((x) => (x.id || x.idDescuentoCatalogo) === formDescuento.idDescuentoCatalogo);
            setItemValue(participanteDescuento.numero, "codigoDescuento", catSel ? (catSel.codigo + " - " + catSel.descripcion) : "");
            setItemValue(participanteDescuento.numero, "montoDescuento", monto);
            setDialogoDescuentoAbierto(false);
            mostrarMensajeDescuento("success", "Descuento registrado. Guarde la terapia para aplicarlo.");
        } catch (e) {
            mostrarMensajeDescuento("error", "No se pudo registrar el descuento.");
        }
    }

    const fecthEntity = useCallback(async () => {
        const response = await api.get("/Terapia/GetsTerapiaParticipanteView?idTerapia=" + params.id)
            .catch((err) => {
                console.log("Err: ", err)
            });
        
        if (response.data.data == null || response.data.data.length == 0)
            dispatch(setEntity(defaultEntity));
        else
            dispatch(setEntity(response.data.data));
    }, [])
    const fetchParticipantes = useCallback(async (idFilial = idFilialEfectiva) => {
        if (!idFilial || idFilial <= 0) {
            dispatch(setParticipantes([]));
            return;
        }
        const data = await participanteService.getsParticipantesResumenView(true, true, idFilial)
            .catch((err) => {
                console.log("Err: ", err);
                return [];
            });
        
        dispatch(setParticipantes(data || []));
    }, [idFilialEfectiva, dispatch])
    const fetchEstados = useCallback(async () => {
        const response = await api.get("/Catalogo/GetCatalogosByIdPadreInLista?idPadre=1")
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setEstados(response.data.data));
    }, [])

    useEffect(() => {
        fecthEntity();
        fetchEstados();
        fetchDescuentoCatalogo();
        fetchTiposDescuento();
    }, [])

    useEffect(() => {
        fetchParticipantes(idFilialEfectiva);
    }, [idFilialEfectiva, fetchParticipantes]);

    const fetchTiposDescuento = useCallback(async () => {
        const data = await catalogoService.getCatalogosByPadre(315).catch(() => []);
        setListTiposDescuento(data || []);
    }, [])

    const fetchDescuentoCatalogo = useCallback(async () => {
        const data = await descuentoCatalogoService.getsDescuentoCatalogoActivos().catch((err) => { console.log(err); return []; });
        setListDescuentoCatalogo(data || []);
    }, [])

    useEffect(() => {
        dispatch(setValidations(messagesValidation()));
    }, [entity])

    useEffect(() => {
        
    }, [entity])

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    const deleteEntity = async () => {
        try {
            await api.delete("/Terapia/DeteleTerapiaParticipante?idTerapia="
                    + params.id + "&numero=" + selectNumero);

            dispatch(remove(selectNumero));
        } catch (err) {
            // Por ejemplo, cuando el participante ya tiene periodos de terapia.
            const mensaje = err?.response?.data?.detail
                || "No se puede eliminar el participante (verifique que no tenga periodos de terapia).";

            console.log("Err: ", err);

            mostrarMensajeDescuento("error", mensaje);
        } finally {
            setOpenDialogDelete(false);
        }

        return;
    }
 
    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Participantes (" + (entity != null ? entity.length : 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <IconButton disabled={isReadOnly} size="small" aria-label="Agregar Participante" style={{height: 10}} onClick={() => {
                    dispatch(add(params.id));
                }}>
                    <IconAddCircle />
                </IconButton>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(entity)} */}
                {/* {JSON.stringify(numeroDocumentoExistente)} */}
                <Table size="small" sx={{ width: "100%" }}>
                    <TableBody>
                        {entity.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell sx={{ px: 0.5, py: 1 }}>
                                    <Grid container spacing={1} padding={0} sx={{ alignItems: "center", maxWidth: { lg: 860 } }}>
                                        <Grid item xs={12} md={7} lg={8}>
                                            <FormControl required fullWidth error={validate.participante && validation.participante.error}>
                                                <Autocomplete
                                                    name="idParticipante"
                                                    value={listParticipantes.find((x) => x.id === row.idParticipante) || (row.participante ? { id: row.idParticipante || 0, participante: row.participante } : null)}
                                                    inputValue={row.participante == null ? "" : row.participante}
                                                    onInputChange={(event, newInputValue, reason) => {
                                                        setItemValue(row.numero, "participante", newInputValue || "");
                                                        if (reason === "clear" || !newInputValue) {
                                                            setItemValue(row.numero, "idParticipante", 0);
                                                            setItemValue(row.numero, "idPersona", null);
                                                        }
                                                    }}
                                                    onChange={(event, newValue) => {
                                                        setItemValue(row.numero, "idParticipante", newValue == null ? 0 : newValue.id);
                                                        setItemValue(row.numero, "idPersona", newValue == null ? null : (newValue.idPersona || null));
                                                        setItemValue(row.numero, "participante", newValue == null ? "" : newValue.participante);
                                                    }}
                                                    options={listParticipantes}
                                                    autoHighlight
                                                    disabled={isReadOnly || (row.id > 0 && Boolean(row.tieneSesiones || row.tienePagos))}
                                                    getOptionLabel={(option) => (typeof option === "string" ? option : (option?.participante || ""))}
                                                    isOptionEqualToValue={(option, value) => option?.id === (value?.id ?? value)}
                                                    renderOption={(props, option) => {
                                                        return (
                                                            <li {...props} key={option.id}>
                                                            {option.participante}
                                                            </li>
                                                        );
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Participante"
                                                            variant="outlined"
                                                            inputProps={{
                                                                ...params.inputProps,
                                                                autoComplete: 'new-password',
                                                            }}
                                                        />
                                                    )}
                                                    size="small"
                                                />
                                                <HelperText>{Boolean(row.tieneSesiones || row.tienePagos) ? "Bloqueado por sesiones o pagos registrados" : (validate.participante && validation.participante?.error ? validation.participante.message : "")}</HelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={8} sm={6} md={4} lg={3}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-estado">Estado</InputLabel>
                                                <Select
                                                    native
                                                    label="Estado"
                                                    value={row.idEstado}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idEstado", event.target.value)
                                                        setItemValue(row.numero, "estado", event.nativeEvent.target[id].text)
                                                    }}
                                                    inputProps={{
                                                        name: 'idEstado',
                                                        id: 'input-estado',
                                                    }}
                                                    disabled={isReadOnly}
                                                    size="small"
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {listEstados.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4} sm={2} md={1} sx={{ display: "flex", alignItems: "center" }}>
                                            <IconButton aria-label="delete" disabled={isReadOnly || (row.id > 0 && Boolean(row.tieneSesiones || row.tienePagos))} onClick={() => {
                                                if (row.id > 0) {
                                                    setSelectId(row.id);
                                                    setSelectNumero(row.numero);
                                                    setOpenDialogDelete(true);
                                                }
                                                else {
                                                    dispatch(remove(row.numero));
                                                }

                                            }}>
                                                <IconDelete />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                                                        <Grid container spacing={1} padding={0} sx={{ mt: 0.5, alignItems: "center" }}>
                                                                            <Grid item xs={12} sm={6} md={4} lg={5}>
                                                                                <TextField disabled size="small" fullWidth label="Cod. Descuento"
                                                                                    value={row.codigoDescuento == null ? "" : row.codigoDescuento} />
                                                                            </Grid>
                                                                            <Grid item xs={12} sm={6} md={4} lg={5}>
                                                                                <TextField disabled size="small" fullWidth label="Monto Descuento"
                                                                                    value={row.montoDescuento == null ? "" : row.montoDescuento} />
                                                                            </Grid>
                                                                            <Grid item xs={4} sm={2} md={1} sx={{ display: "flex", alignItems: "center" }}>
                                                                                <IconButton size="small" disabled={isReadOnly} onClick={() => abrirRegistroDescuento(row)}>
                                                                                    <IconDescuento />
                                                                                </IconButton>
                                                                            </Grid>
                                                                        </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth
                    error={
                        (validate.AtLeastOneRow && validation.AtLeastOneRow.error)
                    }>

                    <HelperText>
                        {validate.AtLeastOneRow && validation.AtLeastOneRow.error ? validation.AtLeastOneRow.message : ""}
                    </HelperText>
                </FormControl>
            </Grid>
             <DialogoCredenciales abierto={dialogoCredencialesAbierto} accion="descuento.registrar" acceso="descuento.editar" titulo="Aprobar registro de descuento" mensaje="Quien aprueba debe tener acceso descuento.editar." onCancelar={() => setDialogoCredencialesAbierto(false)} onConfirmar={(data) => { setTokenAprobacion(data?.token || ""); setDialogoCredencialesAbierto(false); setDialogoDescuentoAbierto(true); }} />
             <Dialog open={dialogoDescuentoAbierto} fullWidth maxWidth="xs" onClose={() => setDialogoDescuentoAbierto(false)}>
                 <DialogTitle>Registrar descuento</DialogTitle>
                 <DialogContent>
                     <Grid container spacing={1} sx={{ paddingTop: '12px' }}>
                         <Grid item xs={12} sm={12}><TextField select size="small" fullWidth label="Descuento catalogo" value={formDescuento.idDescuentoCatalogo} onChange={(e) => { const id = parseInt(e.target.value); const cat = (listDescuentoCatalogo || []).find((x) => (x.id || x.idDescuentoCatalogo) === id); setFormDescuento({...formDescuento, idDescuentoCatalogo: id, idTipoCalculo: cat ? cat.idTipoDescuento : 0, valor: cat ? cat.valor : 0, isPorcentaje: true}); }} SelectProps={{ native: true }}><option value={0}>(Seleccione)</option>{(listDescuentoCatalogo || []).map((c) => (<option key={c.id || c.idDescuentoCatalogo} value={c.id || c.idDescuentoCatalogo}>{(c.codigo || '') + ' - ' + (c.descripcion || '')}</option>))}</TextField></Grid>
                         <Grid item xs={12} sm={12}></Grid>
                         <Grid item xs={12} sm={6}><TextField size="small" fullWidth label="Tipo de calculo" value={(listTiposDescuento || []).find((t) => (t.id || t.idCatalogo) === formDescuento.idTipoCalculo)?.descripcion || ''} disabled /></Grid>
                         <Grid item xs={12} sm={6}><TextField size="small" fullWidth label="Valor" value={formDescuento.valor} disabled /></Grid>
                         <Grid item xs={12} sm={6}><TextField type="date" size="small" fullWidth label="Inicio" value={formDescuento.fechaInicio} onChange={(e) => setFormDescuento({...formDescuento, fechaInicio: e.target.value})} InputLabelProps={{ shrink: true }} /></Grid>
                         <Grid item xs={12} sm={6}><TextField type="date" size="small" fullWidth label="Fin" value={formDescuento.fechaFin} onChange={(e) => setFormDescuento({...formDescuento, fechaFin: e.target.value})} InputLabelProps={{ shrink: true }} /></Grid>
                     </Grid>
                 </DialogContent>
                 <DialogActions>
                     <Button onClick={() => setDialogoDescuentoAbierto(false)}>Cancelar</Button>
                     <Button variant="contained" onClick={registrarDescuento}>Registrar</Button>
                 </DialogActions>
             </Dialog>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deleteEntity}
                setNo={() => { return }}
                titulo={"Borrar participante"}
                texto={"Esta seguro de borrar el participante?"}
            ></DialogYesNo>
            <Snackbar open={mensajeDescuento.open} autoHideDuration={5000} onClose={() => setMensajeDescuento({ ...mensajeDescuento, open: false })}>
                <Alert severity={mensajeDescuento.severity} onClose={() => setMensajeDescuento({ ...mensajeDescuento, open: false })}>{mensajeDescuento.text}</Alert>
            </Snackbar>
        </Grid>
    )
}

export default TherapyMember;

